import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import { Menu, MenuItem, Fade } from '@mui/material';
import moment from 'moment';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';

import EditUser from './components/EditUser';
import AddUser from './components/AddUser';
import CustomTableV2 from '../../common/CustomTableV2';
import CustomSliderModalV2 from '../../common/CustomSliderModalV2';
import SignupLink from '../RegisteredOrganization/components/SignupLink';
import UserDetails from './components/UserDetails';

import { GetUsers } from "../../redux/user/actions";
import { GetMyProfile } from "../../redux/profile/actions";

import "./style.css";
import { apiCallV2 } from '../../utils/api';

function Users(props) {
    const { company, token, name, adminID } = JSON.parse(localStorage.getItem("admin-info"));
    const [data, setData] = useState([])

    // MENU STATES
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentIndex, setCurrentIndex] = useState('');
    const open = Boolean(anchorEl);
    const handleClick = (event, index) => {
        setCurrentIndex(index)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // SLIDER STATES
    const [user, setUser] = useState('')
    const [showModal, setShowModal] = useState(false)
    const [showType, setShowType] = useState(false)
    const [goals, setGoals] = useState([])
    const [programs, setPrograms] = useState([])

    const sliderTitles = {
        add: "ADD USER",
        edit: "EDIT USER",
        qr: "ONBOARDING LINK",
    }

    useEffect(() => {
        const cb = async () => {
            let [goals, programs] = await Promise.all([
                apiCallV2(
                    "GET",
                    "get-survey-goals",
                    {},
                    localStorage.getItem("access-token")
                ),
                apiCallV2(
                    "GET",
                    "get-indi-programs-v2",
                    "",
                    localStorage.getItem("access-token"),
                    {
                        page: 1,
                        limit: 100,
                    },
                )
            ]
            );
            setGoals(goals?.data?.data?.goals || []);
            setPrograms(programs?.data?.programs || []);
        }
        cb();
    }, []);

    return (
        <div className="main-container">
            <Fade in>
                <div>
                    <CustomTableV2
                        title="APP USERS"
                        description="Control permission of users."
                        store={props.User}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Last Name", value: "last_name", },
                                { title: "First Name", value: "first_name", },
                                { title: "Email Address", value: "email_address", },
                                { title: "Company", value: "company", },
                                { title: "DOB", },
                                { title: "" },
                            ],
                            body: (user, i) => {
                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{user.last_name?.toUpperCase()}</h5></td>
                                        <td><h5>{user.first_name?.toUpperCase()}</h5></td>
                                        <td><h5>{user.email_address}</h5></td>
                                        <td><h5>{user.name?.toUpperCase()}</h5></td>
                                        <td><h5>{user?.dob ? (moment(user?.dob).format('MMM-DD-YYYY'))?.toUpperCase() : '-'}</h5></td>
                                        <td>
                                            <h5>
                                                <MoreHorizIcon
                                                    id="basic-button"
                                                    onClick={(e) => handleClick(e, i)}
                                                    sx={{ fontSize: 40, cursor: 'pointer' }}
                                                />
                                                {i === currentIndex && (
                                                    <Menu
                                                        sx={{ zIndex: 800 }}
                                                        id="basic-menu"
                                                        anchorEl={anchorEl}
                                                        open={open}
                                                        onClose={handleClose}
                                                        MenuListProps={{
                                                            'aria-labelledby': 'basic-button',
                                                        }}
                                                    >
                                                        <MenuItem onClick={() => {
                                                            setUser(user);
                                                            handleClose();
                                                            setShowModal(true);
                                                            setShowType("edit");
                                                        }}> Edit</MenuItem>

                                                        <MenuItem onClick={() => {
                                                            setUser(user);
                                                            handleClose();
                                                            setShowModal(true);
                                                            setShowType("show-details");
                                                        }}> Show Detail</MenuItem>

                                                    </Menu>
                                                )}
                                            </h5>
                                        </td>
                                    </tr>
                                )
                            }
                        }}
                        actions={{
                            add: () => {
                                setShowModal(true);
                                setShowType("add");
                            },
                            qr: name && token ? () => {
                                setShowModal(true);
                                setShowType("qr");
                            } : null,
                            get: (page, count, filter, sort) => {
                                props.GetUsers(page, count, company ? { ...filter, company: company, adminID: adminID } : filter, sort);
                            }
                        }}
                    />
                </div>
            </Fade>

            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={sliderTitles[showType]}>
                {
                    showType == "add" &&
                    <AddUser data={data} setData={setData} />
                }
                {
                    showType == "edit" &&
                    <EditUser user={user || ''} setShow={showModal} data={data} setData={setData} />
                }

                {
                    showType == "show-details" &&
                    <UserDetails user={user || ''} setShow={showModal} data={data} setData={setData} goals={goals} programs={programs} />
                }

                {
                    showType == "qr" &&
                    <SignupLink organization={{ name: name, token: token }} />
                }

            </CustomSliderModalV2>
        </div>

    );
}

const mapStateToProps = (state) => ({
    User: state.User
})

export default connect(mapStateToProps, {
    GetUsers,
    GetMyProfile,
})(Users);
